import React, { useState } from 'react';
import {
  CheckmarkIcon,
  EmailIcon,
  PhoneIcon,
  SendIcon,
  ArrowRightIcon,
  ArrowLeftIcon,
} from '../icons/OnboardingIcons';

const VerificationStep = ({ formData, updateFormData, onNext, onBack }) => {
  const [emailSent, setEmailSent] = useState(false);
  const [phoneSent, setPhoneSent] = useState(false);

  const handleSendEmail = () => {
    // Simulate sending email
    setEmailSent(true);
    setTimeout(() => {
      updateFormData('emailVerified', true);
    }, 2000);
  };

  const handleSendPhone = () => {
    // Simulate sending SMS
    setPhoneSent(true);
    setTimeout(() => {
      updateFormData('phoneVerified', true);
    }, 2000);
  };

  const canContinue = formData.emailVerified && formData.phoneVerified;

  return (
    <div className="v2-verification-step">
      <div className="v2-step-header">
        <div className="v2-step-icon v2-step-icon--red">
          <CheckmarkIcon size={24} />
        </div>
        <h2 className="v2-step-title">Step 1: Verify Contact Information</h2>
      </div>

      <p className="v2-step-description">
        Verify email and phone number before proceeding. Links will be sent for verification.
      </p>

      {/* Email Verification */}
      <div className="v2-verification-section">
        <div className="v2-verification-header">
          <EmailIcon />
          <h3 className="v2-verification-title">Email Verification</h3>
        </div>

        <div className="v2-form-group">
          <label className="v2-form-label">
            Email Address <span className="v2-form-required">*</span>
          </label>
          <div className="v2-verification-input-group">
            <input
              type="email"
              className="v2-form-input"
              placeholder="owner@gym.com"
              value={formData.email}
              onChange={(e) => updateFormData('email', e.target.value)}
              disabled={formData.emailVerified}
            />
            {!formData.emailVerified && (
              <button
                className="v2-btn v2-btn--send"
                onClick={handleSendEmail}
                disabled={!formData.email || emailSent}
              >
                <SendIcon />
                Send Link
              </button>
            )}
            {formData.emailVerified && (
              <span className="v2-verification-status v2-verification-status--verified">
                <CheckmarkIcon />
                Verified
              </span>
            )}
          </div>
          <div className="v2-verification-status-text">
            {!formData.emailVerified && !emailSent && 'Email: -'}
            {emailSent && !formData.emailVerified && (
              <span className="v2-status-pending">Pending</span>
            )}
            {formData.emailVerified && (
              <span className="v2-status-verified">
                Email: {formData.email}
                <CheckmarkIcon size={14} />
                Verified
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Phone Verification */}
      <div className="v2-verification-section">
        <div className="v2-verification-header">
          <PhoneIcon />
          <h3 className="v2-verification-title">Phone Verification</h3>
        </div>

        <div className="v2-form-group">
          <label className="v2-form-label">
            Phone Number <span className="v2-form-required">*</span>
          </label>
          <div className="v2-verification-input-group">
            <input
              type="tel"
              className="v2-form-input"
              placeholder="+91 9876543210"
              value={formData.phone}
              onChange={(e) => updateFormData('phone', e.target.value)}
              disabled={formData.phoneVerified}
            />
            {!formData.phoneVerified && (
              <button
                className="v2-btn v2-btn--send"
                onClick={handleSendPhone}
                disabled={!formData.phone || phoneSent}
              >
                <SendIcon />
                Send Link
              </button>
            )}
            {formData.phoneVerified && (
              <span className="v2-verification-status v2-verification-status--verified">
                <CheckmarkIcon />
                Verified
              </span>
            )}
          </div>
          <div className="v2-verification-status-text">
            {!formData.phoneVerified && !phoneSent && 'Phone: -'}
            {phoneSent && !formData.phoneVerified && (
              <span className="v2-status-pending">Pending</span>
            )}
            {formData.phoneVerified && (
              <span className="v2-status-verified">
                Phone: {formData.phone}
                <CheckmarkIcon size={14} />
                Verified
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="v2-step-actions">
        <button className="v2-btn v2-btn--back" onClick={onBack}>
          <ArrowLeftIcon />
          Back
        </button>
        <button className="v2-btn v2-btn--primary" onClick={onNext} disabled={!canContinue}>
          Continue to Business Info
          <ArrowRightIcon />
        </button>
      </div>
    </div>
  );
};

export default VerificationStep;
